"use strict";

const InputBaseSingleOptionSelectionControlComponent = require("../single/InputBaseSingleOptionSelectionControlComponent");
const _ = require("lodash");

class InputBaseMultipleOptionSelectionControlComponent extends InputBaseSingleOptionSelectionControlComponent {
    /**
     * @schema.name Input Base Multiple Option Selection Control
     *
     * @schema.configuration.value.name value
     * @schema.configuration.value.type array
     * @schema.configuration.value.default []
     * @schema.configuration.value.required false
     */

    constructor(configOptions) {
        super(configOptions);
        this.setValue(_.get(configOptions, "value", []));
    }
    /*******************************************/
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setValue.name setValue
     * @schema.methods.setValue.description Sets the passed in values selected within the control and returns an instance of the control for chainability
     * @schema.methods.setValue.returns Instance of the control
     * @schema.methods.setValue.parameters.newVal.name newVal
     * @schema.methods.setValue.parameters.newVal.description An array of values that correspond to the 'value' property of an option
     * @schema.methods.setValue.parameters.newVal.type array
     * @schema.methods.setValue.parameters.wasTriggeredByUser.name wasTriggeredByUser
     * @schema.methods.setValue.parameters.wasTriggeredByUser.description Flag alerting that this was a user-triggered change (optional)
     * @schema.methods.setValue.parameters.wasTriggeredByUser.required false
     * @schema.methods.setValue.parameters.wasTriggeredByUser.type boolean
     */
    setValue(newVal, wasTriggeredByUser) {
        if (newVal instanceof Array) {
            let oldVal = _.cloneDeep(this._value);
            this._value = newVal;
            this.emit("Value", this._value, oldVal, wasTriggeredByUser);
        } else {
            console.error("The value for this control is not an array.");
        }
        return this;
    }
    /**
     * @schema.methods.getValue.name getValue
     * @schema.methods.getValue.description Returns the value of the control
     * @schema.methods.getValue.returns array
     */
    getValue() {
        return this._value;
    }
    get value() {
        return this.getValue();
    }
    set value(newVal) {
        return this.setValue(newVal);
    }

    /**
     * @schema.methods.setSelectedOptions.name setSelectedOptions
     * @schema.methods.setSelectedOptions.description Sets the passed in values selected within the control and returns an instance of the control for chainability
     * @schema.methods.setSelectedOptions.returns Instance of the control
     * @schema.methods.setSelectedOptions.parameters.newVal.name newVal
     * @schema.methods.setSelectedOptions.parameters.newVal.description An array of values that correspond to the 'value' property of an option
     * @schema.methods.setSelectedOptions.parameters.newVal.type array
     */
    setSelectedOptions(values) {
        this.setValue(values);
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

/**
 * @schema.methods.setSelectedOption.name undefined
 * @schema.methods.setSelectedOption.description undefined
 * @schema.methods.setSelectedOption.returns undefined
 * @schema.methods.setSelectedOption.parameters.value.name undefined
 * @schema.methods.setSelectedOption.parameters.value.description undefined
 * @schema.methods.setSelectedOption.parameters.value.type undefined
 */
InputBaseMultipleOptionSelectionControlComponent.setSelectedOption = undefined;

module.exports = InputBaseMultipleOptionSelectionControlComponent;
